import React from 'react';
import { costOfInaction } from '../data/content';
export function CostSection() {
  return <section className="w-full bg-cream-100 px-6 py-20 sm:py-24" aria-labelledby="costo-titulo" data-id="element-16" data-mp="9bem7yndii15">
      <div className="mx-auto max-w-6xl" data-id="element-17" data-mp="4kofoi37o94v">
        <span className="text-sm font-semibold text-ember-500" data-id="element-18" data-mp="4jn5efu0rqo7">El costo de no tenerlo</span>
        <h2 id="costo-titulo" className="mt-4 max-w-2xl font-display text-3xl font-bold leading-tight text-forest-800 sm:text-4xl lg:text-[2.75rem]" data-id="element-19" data-mp="3vqpsav2trasm">
          Sin el Kit Instrumentación Industrial perdés:
        </h2>

        <ul className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-20" data-mp="3hrq3nnfbavwg">
          {costOfInaction.map(({
          icon: Icon,
          title,
          description
        }) => <li key={title} className="flex h-full gap-4 border-l-2 border-ember-100 pl-5" data-id="element-21" data-mp="3cu7ym84f10tq">
              <Icon className="mt-1 h-5 w-5 shrink-0 text-ember-500" aria-hidden="true" data-id="element-22" data-mp="1fzuzdsvdxto9" />
              <div data-id="element-23" data-mp="1b2ldgn77g056">
                <h3 className="font-display text-lg font-semibold text-forest-800" data-id="element-24" data-mp="1b235wuf3dzhy">{title}</h3>
                <p className="mt-1.5 text-base leading-relaxed text-forest-700/70" data-id="element-25" data-mp="p6a0a7x7lpkm">{description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}